import pet_medics_logo from "../assets/home/pet_medics_logo.png"
import pet_medics_symbol from "../assets/home/pet_medics_symbol.png"
import { useSiteContent } from "../contexts/siteContentContext";

export default function HeroIcon() {
    const { getContent } = useSiteContent();
    const logoUrl = getContent("settings.logo_url", "");
    const symbolUrl = getContent("settings.symbol_url", "");

    return (
        <>
        <a href="/home" className="flex items-center h-full">
            <img
                src={logoUrl || pet_medics_logo}
                alt="Pet Medics Logo"
                className="hidden md:block object-contain h-full max-h-full cursor-pointer hover:opacity-80 transition-all duration-200 ease-out"
            />
            <img
                src={symbolUrl || pet_medics_symbol}
                alt="Pet Medics Symbol"
                className="md:hidden block object-contain h-full max-h-full cursor-pointer"
            />
        </a>
        </>
    )
}
